import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { SlLocationPin } from "react-icons/sl";
import { MdOutlineCalendarMonth } from "react-icons/md";
import { IoCloudOfflineOutline } from "react-icons/io5";

const AccessLogsScreen = () => {
    const navigate = useNavigate()
    const singleEvent = useSelector((state) => state?.community?.singleEvent);
    const GetEventAccesslogs = useSelector((state) => state?.community?.geteventaccessbyId);
    
    const formatDate = (dateString) => {
        if (!dateString) return "";
        const date = new Date(dateString);
        return date.toLocaleDateString('en-US', {
            day: 'numeric',
            month: 'long',
            year: 'numeric'
        });
    };

    const formatDisplayDate = (dateString) => {
        if (!dateString) return "";
        const date = new Date(dateString);
        return date.toLocaleDateString('en-US', {
            day: '2-digit',
            month: 'short',
            year: 'numeric'
        });
    };

    const formatTime = (dateString) => {
        if (!dateString) return "";
        const date = new Date(dateString);
        return date.toLocaleTimeString('en-US', {
            hour: '2-digit',
            minute: '2-digit',
            hour12: true
        });
    };

    const handleGoBack = () => {
        navigate(-1); // Goes back to previous page
    }

    const primaryBlue = "#0044C6";

    // Get location from singleEvent
    const eventLocation = singleEvent?.event_location || "";

    // Get date from singleEvent
    const eventDate = formatDate(singleEvent?.start_time);

    // Extract performer name from created_by string
    const getPerformerName = (createdBy) => {
        if (!createdBy) return "Unknown";
        const match = createdBy.match(/^([^<]+)/);
        return match ? match[1].trim() : createdBy;
    };

    return (
        <div style={{ width: "95%", minHeight: "100vh", background: "#f5f7fa" }}>


            {/* Access Logs Section */}
            <div style={{
                background: "white",
                borderRadius: "16px",
                boxShadow: "0 4px 20px rgba(0,0,0,0.05)",
                overflow: "hidden",
            }}>
                <div style={{
                    padding: "1.5rem",
                    borderBottom: "1px solid #E5E9F0",
                    display: "flex",
                    gap: "10px"
                }}>
                    <h1 onClick={handleGoBack} ><span style={{ fontSize: "1.2rem" }}>←</span></h1>
                    <h2 style={{
                        fontSize: "1.25rem",
                        fontWeight: 600,
                        color: "#0B1C33",
                        margin: 0,
                    }}>
                        Access Logs
                    </h2>
                </div>

                <div style={{ padding: "1rem" }}>
                    {GetEventAccesslogs && GetEventAccesslogs.length > 0 ? (
                        GetEventAccesslogs.map((log, index) => (
                            <div
                                key={log.id || index}
                                style={{
                                    padding: "1rem",
                                    borderBottom: index < GetEventAccesslogs.length - 1 ? "1px solid #E5E9F0" : "none",
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                    flexWrap: "wrap",
                                    gap: "1rem",
                                }}
                            >
                                {/* Left side - User info */}
                                <div style={{ display: "flex", alignItems: "center", gap: "1rem", flex: 2, minWidth: "250px" }}>
                                    <div style={{
                                        width: "48px",
                                        height: "48px",
                                        borderRadius: "50%",
                                        background: "#E5E9F0",
                                        overflow: "hidden",
                                        flexShrink: 0,
                                    }}>

                                        <img
                                            src={log.attendee.profile_url || "https://static.vecteezy.com/system/resources/thumbnails/009/292/244/small/default-avatar-icon-of-social-media-user-vector.jpg"}
                                            alt={log.attendee.name}
                                            style={{
                                                width: "100%",
                                                height: "100%",
                                                objectFit: "cover",

                                            }}
                                            onError={(e) => {
                                                e.target.src = "https://static.vecteezy.com/system/resources/thumbnails/009/292/244/small/default-avatar-icon-of-social-media-user-vector.jpg";
                                            }}
                                        />

                                    </div>
                                    <div>
                                        <div style={{
                                            fontWeight: 600,
                                            color: "#0B1C33",
                                            marginBottom: "0.25rem",
                                        }}>
                                            {log.attendee?.name || "Unknown User"}
                                        </div>
                                        <div style={{
                                            fontSize: "0.875rem",
                                            color: "#5A6874",
                                        }}>
                                            {log.attendee?.email || "No email"}
                                        </div>
                                    </div>
                                </div>

                                {/* Middle - Performed By */}
                                <div style={{ flex: 2, minWidth: "200px" }}>
                                    <div style={{
                                        fontSize: "0.875rem",
                                        color: "#5A6874",
                                        marginBottom: "0.25rem",
                                    }}>
                                        Performed By :
                                    </div>
                                    <div style={{
                                        fontWeight: 500,
                                        color: "#0B1C33",
                                    }}>
                                        {getPerformerName(log.created_by)}
                                    </div>
                                </div>

                                {/* Right side - Date and Status */}
                                <div style={{
                                    flex: 1,
                                    minWidth: "150px",
                                    display: "flex",
                                    flexDirection: "column",
                                    alignItems: "flex-end",
                                    gap: "0.5rem",
                                }}>
                                    <div style={{
                                        fontSize: "0.875rem",
                                        color: "#5A6874",
                                    }}>
                                        {formatDisplayDate(log.created_at)} • {formatTime(log.created_at)}
                                    </div>
                                    <div style={{
                                        display: "inline-block",
                                        padding: "0.25rem 1rem",
                                        borderRadius: "40px",
                                        fontSize: "0.75rem",
                                        fontWeight: 600,
                                        textTransform: "uppercase",
                                        letterSpacing: "0.5px",
                                        background: log.action === "APPROVED" ? "#E6F7E6" : "#FFE5E5",
                                        color: log.action === "APPROVED" ? "#00A86B" : "#FF3B3B",
                                        border: log.action === "APPROVED" ? "1px solid #00A86B20" : "1px solid #FF3B3B20",
                                    }}>
                                        {log.action}
                                    </div>
                                </div>
                            </div>
                        ))
                    ) : (
                        <div style={{
                            padding: "3rem",
                            textAlign: "center",
                            color: "#5A6874",
                        }}>
                            No access logs available
                        </div>
                    )}
                </div>
            </div>

        </div>
    )
}

export default AccessLogsScreen;